import styled from 'styled-components';
import {injectAdaptive} from 'ui/theme';
import PlusIcon from 'assets/add-to-home.svg';

export const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 30;
  color: ${(p) => p.theme.light};
  line-height: 1.4;
  text-align: center;
  background: ${(p) => p.theme.dark};
`;

const Content = styled.div`
  position: absolute;
  right: 0;
  left: 0;
  max-width: 250px;
  margin: auto;
`;

export const Top = styled(Content)`
  padding: 85px 0 0 0;
  background-image: url('${PlusIcon}');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 70px auto;
  ${injectAdaptive('top', ['45px', '50px', '60px', '70px', '80px'])}
`;

export const Bottom = styled(Content)`
  bottom: 30px;
  ${injectAdaptive('padding-bottom', ['70px', '80px', '80px', '90px', '90px'])}

  &::before,
  &::after {
    position: absolute;
    right: 0;
    left: 0;
    display: block;
    margin: auto;
    content: '';
  }

  &::before {
    bottom: 0;
    width: 2px;
    background: ${(p) => p.theme.yellow};
    ${injectAdaptive('height', ['60px', '70px', '70px', '80px', '80px'])}
  }

  &::after {
    bottom: 2px;
    width: 25px;
    height: 25px;
    border: 2px solid ${(p) => p.theme.yellow};
    border-top: 0;
    border-right: 0;
    transform: rotate(-45deg);
    transform-origin: center;
  }

  img {
    width: 14px;
    margin: 2px 0 -2px 6px;
    vertical-align: baseline;
  }
`;
